import { render } from "./ReceiverPackage.vue?vue&type=template&id=da610cbc&scoped=true"
import script from "./ReceiverPackage.vue?vue&type=script&lang=js"
export * from "./ReceiverPackage.vue?vue&type=script&lang=js"

import "./ReceiverPackage.vue?vue&type=style&index=0&id=da610cbc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da610cbc"]])

export default __exports__